<template>
    <section>
        <h3 class="text-center">Customer Sources</h3>        

        <section style="display: flex; justify-content: center;" v-if="loading === false">
          <Bar
              :options="chartOptions"
              :data="chartData"
            />
        </section>

    </section>
</template>
<script>
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    name: 'CustomerSources',
    components: { Bar },
    data() {
        return {
            customerSources: [],
            loading: true,
            chartOptions: {
                responsive: true,
                maintainAspectRatio: true
            }
        }
    },
    methods: {
        getCustomerSources() {
            this.$store.dispatch('GET_CUSTOMER_SOURCES').then(response => {
                this.customerSources = response.customer_sources;
                this.labels = response.customer_sources.map(source => {
                  return source.name;
                });
                this.loading = false;
            });
        },
        processChartData() {
          const data = this.customerSources.map(source => {
            return source.customers_count;
          });
          return data;
        }
    },
    created()
    {
      this.getCustomerSources();
    },
    computed:{
      chartData(){
          return {
              labels: this.labels,
              datasets: [ { label: `Customer Sources`, data: this.processChartData() } ]
          }
      }
    }
}
</script>
<style scoped>

</style>
